export default {
  data: [
    {
      name: 'Easy shop (ไม่มีร้านค้า)',
      imagePath: '/static/img/assets/preset/1/bg.jpg',
      screenshotPath: '/static/img/assets/preset/1/screenshot.png',
      description: `เหมาะกับใคร: ธุรกิจที่ขายสินค้าและต้องการปิดการขายได้รวดเร็วผ่านแชทบอท`,
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และสามารถสร้างคาแรคเตอร์ในการตอบได้',
        'มีปุ่มกดไปดูข้อมูลหน้าอื่นได้',
        'เมื่อกดติดต่อแอดมิน ลูกค้าสามารถกดปุ่มเพื่อทำการโทรออกได้ทันที'
      ],
      functions: [
        'สามารถแสดงรายละเอียดสินค้า วิธีการใช้สินค้า รีวิว รวมถึงโปรโมชั่นได้',
        'สรุปยอดรายการสินค้าที่สั่งซื้อได้ผ่านหน้าแชท',
        'เลือกชำระเงินแบบโอนเงินหรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/105599484333369'
    },
    {
      name: 'Easy Shop (พร้อมร้านค้า)',
      imagePath: '/static/img/assets/preset/2/bg.jpg',
      screenshotPath: '/static/img/assets/preset/2/screenshot.png',
      description:
        'เหมาะกับใคร: ธุรกิจที่ขายสินค้าและต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับ  ลูกค้าที่เข้ามาอย่างรวดเร็ว และ เรียกชื่อของลูกค้าเป็นรายบุคคล โดยสามารถสร้างคาแรคเตอร์ในการตอบได้',
        'มีปุ่มกดไปดูข้อมูลหน้าอื่นได้'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้'
      ],
      functions: [
        'แสดงรายละเอียดสินค้า วิธีการเก็บ รีวิว และสาขาของร้าน',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/114999383380324'
    },
    {
      name: 'Healthcare',
      imagePath: '/static/img/assets/preset/3/bg.jpg',
      screenshotPath: '/static/img/assets/preset/3/screenshot.png',
      description:
        'เหมาะกับใคร : ธุรกิจขายอาหารเสริมด้านสุขภาพ ยา สมุนไพรที่ต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดงปุ่มกดรายละเอียดสินค้า และปุ่มซื้อสินค้าได้เอง',
        'ปุ่มติดต่อแอดมินโทรออกได้'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีทั้งระบบขายปลีกและขายส่ง',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้'
      ],
      functions: [
        'แสดงรายละเอียดสินค้า สรรพคุณ รีวิว และโปรโมชั่น',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/110787897141310'
    },
    {
      name: 'Gadget & IT',
      imagePath: '/static/img/assets/preset/4/bg.jpg',
      screenshotPath: '/static/img/assets/preset/4/screenshot.png',
      description:
        'เหมาะกับใคร :ธุรกิจขายอุปกรณ์ไอที เช่น หูฟัง ที่ชาร์จไร้สาย ลำโพงบลูทูธที่ต้องการปิดการขายได้รวดเร็วผ่านแชทบอท',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ เรียกชื่อของลูกค้าเป็นรายบุคคล โดย สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดงปุ่มกดรายละเอียดสินค้า และปุ่มซื้อสินค้าได้เอง',
        'ติดแท็กบทสนทนาที่ลูกค้ากดปุ่มเข้ามาดูได้ เพื่อดูว่าลูกค้าที่กดสนใจซื้อสินค้า มีใครบ้าง',
        'เมื่อติดต่อแอดมินมีปุ่มโทรออก'
      ],
      functions: [
        'แสดงรายละเอียดสินค้า รีวิว เกร็ดความรู้ วิธีถนอมการใช้งาน และแผนที่แต่ละสาขา',
        'สรุปยอดรายการสินค้าที่สั่งซื้อได้ผ่านหน้าแชท',
        'เลือกชำระเงินแบบโอนเงินหรือเก็บเงินปลายทาง '
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/100335401533441'
    },
    {
      name: 'Lifestyle Shopping',
      imagePath: '/static/img/assets/preset/5/bg.jpg',
      screenshotPath: '/static/img/assets/preset/5/screenshot.png',
      description:
        'เหมาะกับใคร :ธุรกิจขายสินค้าสารพัดชนิด ของใช้เบ็ดเตล็ดที่ต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดงปุ่มกด รายละเอียดสินค้า และปุ่มซื้อสินค้าได้เอง',
        'ตั้งเวลาปุ่มกดโปรโมชั่น ให้เป็นไปตามโปรโมชั่นของร้านได้'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีทั้งระบบขายปลีกและขายส่ง',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้'
      ],
      functions: [
        'แสดงรายละเอียดสินค้า วิธีการเดินทางมาร้าน ระยะเวลาส่ง และโปรโมชั่น',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/104990511061578'
    },
    {
      name: 'Fashion Shopping',
      imagePath: '/static/img/assets/preset/6/bg.jpg',
      screenshotPath: '/static/img/assets/preset/6/screenshot.png',
      description:
        'เหมาะกับใคร :ธุรกิจขายสินค้าแฟชั่น เช่น เสื้อผ้า รองเท้า กระเป๋า ที่ต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดง ปุ่มกด  รายละเอียดสินค้า และปุ่มซื้อสินค้าได้เอง',
        'ติดแท็กบทสนทนาที่ลูกค้ากดปุ่มเข้ามาดูได้ เพื่อดูว่าลูกค้าที่กดสนใจซื้อสินค้าแต่ไม่ได้ซื้อ ติดอยู่ขั้นตอนไหนกันมาก'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีทั้งระบบขายปลีกและขายส่ง',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้ '
      ],
      functions: [
        'แสดงรายละเอียดสินค้า ที่อยู่หน้าร้าน วิธีการสั่งซื้อ ระยะเวลาส่งและสามารถใส่ลิ้งก์เว็ปไซต์เช็คพัสดุ',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/111255990425517'
    },
    {
      name: ' Cosmetics/Beauty',
      imagePath: '/static/img/assets/preset/7/bg.jpg',
      screenshotPath: '/static/img/assets/preset/7/screenshot.png',
      description:
        'เหมาะกับใคร : ร้านเครื่องสำอาง,ร้าน Skincare บำรุงผิว,น้ำหอม รวมถึงสินค้าในหมวดหมู่ความงามที่ต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดง ปุ่มกดรายละเอียดสินค้า ปุ่มซื้อสินค้าได้เอง และปุ่มลิ้งก์ไปหน้าเว็ปไซต์ร้านค้าได้',
        'ติดแท็กบทสนทนาที่ลูกค้ากดปุ่มเข้ามาดูได้ เพื่อดูว่าลูกค้าที่กดสนใจซื้อสินค้าแต่ไม่ได้ซื้อ ติดอยู่ขั้นตอนไหนกันมาก'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีทั้งระบบขายปลีกและขายส่ง',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้'
      ],
      functions: [
        'สามารถแสดงรายการสินค้า รายละเอียดสินค้า ที่อยู่หน้าร้าน รีวิว รวมถึงโปรโมชั่น',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/113383966878690'
    },
    {
      name: 'Restaurant/Cafe ',
      imagePath: '/static/img/assets/preset/8/bg.jpg',
      screenshotPath: '/static/img/assets/preset/8/screenshot.png',
      description: 'เหมาะกับใคร :ร้านอาหาร หรือร้านกาแฟที่ต้องการให้ข้อมูลร้านผ่านแชทบอท',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และสามารถสร้างคาแรคเตอร์ในการตอบได้',
        'มีปุ่มกดไปดูข้อมูลหน้าอื่นได้ ',
        'context: ตั้งค่าบทสนทนาที่บังคับให้ลูกค้าตอบคำถามอย่างเป็นขั้นตอน เพื่อให้ได้ คำตอบที่เราต้องการ',
        'ติดแท็กบทสนทนาที่ลูกค้าเลือกกดปุ่มหรือพิมพ์เข้ามา  เพื่อให้รู้ว่าลูกค้าสนใจข้อมูลนั้นๆมากน้อยแค่ไหน'
      ],
      functions: [
        'ให้ข้อมูลได้ทั้ง สถานที่ตั้ง แผนที่ร้าน แนะนำเมนู เบอร์โทร ',
        'ปุ่มแผนที่ร้านลิ้งก์ไป google map',
        'ลูกค้ากดโทรหาร้านได้อัตโนมัติด้วยปุ่มเบอร์โทรร้าน'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/100927224808012'
    },
    {
      name: 'Gold & Jewelry',
      imagePath: '/static/img/assets/preset/9/bg.jpg',
      screenshotPath: '/static/img/assets/preset/9/screenshot.png',
      description:
        'เหมาะกับใคร : ร้านทอง หรือร้านเพชรพลอยที่ต้องการปิดการขายได้อัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ เรียกชื่อของลูกค้าเป็นรายบุคคล โดยสามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปสินค้าเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดง ปุ่มกดรายละเอียดสินค้า ปุ่มซื้อสินค้าได้เอง และปุ่มลิ้งก์ไปหน้าเว็ปไซต์ร้านค้าได้',
        'ติดแท็กบทสนทนาที่ลูกค้ากดปุ่มเข้ามาดูได้ เพื่อดูว่าลูกค้าที่กดสนใจซื้อสินค้าแต่ไม่ได้ซื้อ ติดอยู่ขั้นตอนไหนกันมาก'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการสินค้า',
        'ใส่รูป ราคา รายละเอียด และปริมาณสินค้าในStock ได้',
        'เลือกวิธีการจัดส่งได้หลากหลาย',
        'มีทั้งระบบขายปลีกและขายส่ง',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้ '
      ],
      functions: [
        'สามารถแสดงรายการสินค้า รายละเอียดสินค้า ที่อยู่หน้าร้าน แผนที่ร้าน วิธีการดูแลรักษา วิธีวัดไซส์ ',
        'ปุ่มแผนที่ร้านลิ้งก์ไป google map',
        'ลูกค้าสั่งซื้อสินค้าเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต หรือเก็บเงินปลายทาง'
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/112253176996417'
    },
    {
      name: 'Academy/Training centre',
      imagePath: '/static/img/assets/preset/10/bg.jpg',
      screenshotPath: '/static/img/assets/preset/10/screenshot.png',
      description:
        'เหมาะกับใคร : โรงเรียนหรือสถาบันที่ต้องการให้ข้อมูลคอร์สสอนและต้องการปิดการขายคอร์สอัตโนมัติผ่านบริการร้านค้าครบวงจร',
      features: [
        'ข้อความต้อนรับ: สร้างประสบการณ์พิเศษให้ลูกค้าโดยการต้อนรับลูกค้าที่เข้ามาอย่างรวดเร็ว และ สามารถสร้างคาแรคเตอร์ในการตอบได้',
        'แสดงรูปคอร์สเรียนเป็นแบบสไลด์ข้าง ได้ 10 รูป พร้อมแสดง ปุ่ม ลิ้งก์ไปหน้าเว็ปไซต์สถาบันเพื่อให้ข้อมูลเพิ่มเติม และปุ่มซื้อคอร์สได้เอง ',
        'ติดแท็กบทสนทนาที่ลูกค้ากดปุ่มเข้ามาดูได้ เพื่อดูว่าลูกค้าที่กดสนใจซื้อคอร์สเรียนแต่ไม่ได้ซื้อ ติดอยู่ขั้นตอนไหนกันมาก',
        'context: ตั้งค่าบทสนทนาที่บังคับให้ลูกค้าตอบคำถามอย่างเป็นขั้นตอน เพื่อให้ได้ คำตอบที่เราต้องการ'
      ],
      shopservices: [
        'ใส่ หมวดหมู่และรายการคอร์สเรียน',
        'ใส่รูป ราคา รายละเอียดคอร์ส',
        'มีหน้าสรุปออเดอร์หลังบ้านสามารถติดตามการสั่งซื้อลูกค้าได้ '
      ],
      functions: [
        'สามารถแสดงคอร์สเรียน ผลงานของนักเรียน รายชื่อคุณครู สถานที่ตั้ง รีวิว แนะนำคอร์สเรียน',
        'ปุ่มแผนที่โรงเรียนลิ้งก์ไป google map',
        'ลูกค้าสั่งซื้อคอร์สเรียนเองได้และแอดมินกดสั่งแทนลูกค้าได้เช่นกัน',
        'ลูกค้าเลือกชำระเงินได้ทั้งแบบการโอน ตัดบัตรเครดิต '
      ],
      pages: [],
      isPremium: true,
      link: 'https://m.me/113506140205318'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/data/presets.js